import React, { useEffect, useState } from "react";
import "./CommercialInsurance.css";
import insuranceImg from "../../assets/img/insurance/automobile.svg";
import check_circle from "../../assets/img/insurance/check_circle.svg";
import left_layout_image_Car from "../../assets/img/insurance/left_layout_image_Car.svg";
import left_layout_image_Car_M from "../../assets/img/insurance/left_layout_image_Car_M.svg";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";

const CommercialInsurances = ({ responsiveStatus }) => (
  <div
    className={`flex-1 text-left`}
    style={{ padding: "20px", maxWidth: "1350px", margin: "0 auto" }}
  >
    <p
      className={`${
        responsiveStatus === "isDesktop"
          ? "p-class"
          : responsiveStatus === "isTablet" ||
            responsiveStatus === "isTabletLandscape"
          ? "p-class"
          : "p-class-m"
      }`}
      style={{
        fontSize:
          responsiveStatus === "isTablet" ||
          responsiveStatus === "isTabletLandscape"
            ? "30px"
            : "",
      }}
    >
      <span
        style={{
          position: "relative",
          paddingBottom: ".5em",
        }}
      >
        <span
          className="blue-underline"
          style={{
            paddingBottom: "5px",
          }}
        >
          {" "}
          Commerci
        </span>
        al Auto Insurance
      </span>
    </p>

    <p
      className="text-gray-700 mb-6 max-w-md mx-auto"
      style={{ marginTop: "0.5em" }}
    >
      For more than a decade UAIC has been insuring business automobiles, UAIC
      understands just what you need and when you need it.
    </p>
    <ul style={{ listStyle: "none", padding: 0, margin: 0, marginTop: "20px" }}>
      {[
        "Commercial Policies Available in Florida Only.",
        "Service personalized to suit your coverage needs.",
        "Competitively-priced.",
        "Personalized coverage options.",
        "Coverage for more drivers, vehicle types and businesses than ever before.",
      ].map((item, i) => (
        <li
          key={i}
          style={{
            marginBottom: "12px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={check_circle}
            alt="check"
            style={{ width: "20px", marginRight: "10px" }}
          />
          <span className="textStyle" style={{ fontSize: "16px" }}>
            {item}
          </span>
        </li>
      ))}
    </ul>

    {(responsiveStatus === "isMobile" ||
      responsiveStatus === "isSmallMobile") && (
      <img
        src={left_layout_image_Car_M}
        className={`img-fluid ${
          responsiveStatus === "isDesktop"
            ? "aboutRightImage3"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "aboutRightImage3"
            : "aboutRightImage4"
        }`}
        alt="Car"
        style={{ maxWidth: "100%", height: "auto" }}
      />
    )}
  </div>
);

const CommercialInsurance = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  // const ITEMS_PER_PAGE = 4;

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  return (
    // <div className="min-h-screen flex flex-col md:flex-row">
    <div
      className=""
      style={{
        marginLeft: "0px",
        padding: "0px",
        display: "flex",
        flexWrap: "wrap",
        maxWidth: "1350px",
        margin: "0 auto",
      }}
    >
      <div
        className="d-flex flex-column justify-content-center"
        style={{
          backgroundColor:
            responsiveStatus === "isDesktop"
              ? "#D8f4FF"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "#D8f4FF"
              : "",

          width:
            responsiveStatus === "isDesktop"
              ? "51%"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "51%"
              : "100%",
        }}
      >
        {responsiveStatus !== "isMobile" &&
          responsiveStatus !== "isSmallMobile" && (
            <img
              src={left_layout_image_Car}
              className={`img-fluid ${
                responsiveStatus === "isDesktop"
                  ? "aboutRightImage3"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "aboutRightImage3"
                  : "aboutRightImage4"
              }`}
              alt="Car"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          )}
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          backgroundColor: "#D8f4FF",
          padding: "0px",
          width:
            responsiveStatus === "isDesktop"
              ? "49%"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "49%"
              : "100%",
        }}
      >
        <CommercialInsurances responsiveStatus={responsiveStatus} />
      </div>
    </div>

    // </div>
  );
};

const styles = {
  rightImage: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "auto",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${left_layout_image_Car})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

export default CommercialInsurance;
